import React from 'react';
import { App } from '../types/app';
import { AppCard } from './AppCard';
import './AppGrid.css';

interface AppGridProps {
  apps: App[];
  loading: boolean;
  error: string | null;
  prepend?: React.ReactNode;
}

export const AppGrid: React.FC<AppGridProps> = ({ apps, loading, error, prepend }) => {
  if (loading) {
    return (
      <div className="app-grid-loading">
        <div className="spinner"></div>
        <p>Loading apps...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="app-grid-error">
        <p>Failed to load apps</p>
        <p className="error-detail">{error}</p>
      </div>
    );
  }

  if (apps.length === 0) {
    return (
      <div className="app-grid-empty">
        <p>No apps found</p>
        <p className="empty-detail">Try adjusting your filters</p>
      </div>
    );
  }

  return (
    <div className="app-grid">
      {prepend}
      {apps.map((app) => (
        <AppCard key={app.id} app={app} />
      ))}
    </div>
  );
};
